<template>
    <div class="index" v-cloak>
        <div class="follow acea-row row-between-wrapper" v-if="followHid && isWeixin">
            <div>点击“立即关注”即可关注公众号</div>
            <div class="acea-row row-middle">
                <div class="bnt" @click="followTap">立即关注</div>
                <span class="iconfont icon-guanbi" @click="closeFollow"></span>
            </div>
        </div>
        <div class="followCode" v-if="followCode">
            <div class="pictrue"><img :src="followUrl" /></div>
            <div class="mask" @click="closeFollowCode"></div>
        </div>
        <div class="index-bg">
            <div class="header acea-row row-center-wrapper" v-if="logoUrl">
                <div class="logo"><img :src="logoUrl" /></div>
                <router-link :to="'/search'" class="search acea-row row-middle">
                    <span class="iconfont icon-xiazai5"></span>搜索商品
                </router-link>
            </div>
            <div class="slider-banner banner">
                <swiper :options="swiperOption" v-if="banner.length > 0">
                    <swiper-slide v-for="(item, index) in banner" :key="index">
                        <img :src="item.pic" />
                    </swiper-slide>
                    <div class="swiper-pagination paginationBanner" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <div class="nav acea-row" v-if="menus.length>0">
            <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="item">
                <div class="local">
                    <div class="pictrue">
                        <img v-lazy="index_new" alt="img" />
                    </div>
                    <div>首发新品</div>
                </div>
            </router-link>
            <template v-for="(item, index) in menus">
                <router-link :to="{
          path: '/goods_list',
          query: { id: item.id, title: item.cate_name }
        }" class="item" :key="index">
                    <div class="local">
                        <div class="pictrue"><img v-lazy="item.image" alt="img" /></div>
                        <div>{{ item.cate_name }}</div>
                    </div>
                </router-link>
            </template>
        </div>
        <div class="speak" v-if="activity.length>0">
            <div class="speak-news">
                <div style="height:32px"></div>
                <img :src="activity[0].pic" @click="$router.push({ path: '/news_list' })" alt="">
            </div>
            <div class="speak-new">
                <img :src="activity[1].pic" @click="$router.push({ path: '/video_list' })" alt="">
                <img :src="activity[2].pic" @click="$router.push({ path: '/newborn' })" alt="">
            </div>
        </div>
        <div class="goods-bg" v-if="likeInfo.length>0">
            <div class="txt">
                <span>今</span>
                <span>日</span>
                <span>推</span>
                <span>荐</span>
            </div>
            <div class="txt-con">采用古法食疗的特色加工工艺</div>
        </div>
        <index-goods :likeInfo="likeInfo"></index-goods>
        <div class="card" v-if="!bindAccount && token">
            <div class="card-left">
                <img src="../../assets/newImg/warn.png" alt="" />
                <div class="content">{{bindAccountTips}}</div>
            </div>
            <div class="succ" @click="goToBindAccount">去设置</div>
        </div>
        <div style="height:1.2rem;"></div>
        <div>
            <iframe v-if="mapKey && !isWeixin" ref="geoPage" width="0" height="0" frameborder="0" scrolling="no" :src="'https://apis.map.qq.com/tools/geolocation?key=' + mapKey + '&referer=myapp'"></iframe>
        </div>
        <img src="@assets/newImg/kefu.png" class="kefu" @click="kefu">
        <!-- <van-dialog v-model="mobileShow" title="手机号绑定" @confirm="mobileCancel">
            <van-field v-model="mobileBD" label="手机号" type="number" placeholder="请输入手机号" />
            <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入验证码">
                <template #button>
                    <van-button size="small" type="primary" v-if="time==60" @click="send">发送验证码</van-button>
                    <van-button size="small" type="primary" disabled v-if="time<60" style="width:75px">{{time}}S</van-button>
                </template>
            </van-field>
        </van-dialog> -->
    </div>
</template>
<script>
import Vue from 'vue';
import { Dialog, Field, Button, Toast } from 'vant';
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import indexGoods from "@/components/indexGoods";
import { getHomeData, getShare, follow } from "@api/public";
import { queryCard, getUserInfo, registerVerify, getCodeApi, bindPhone } from "@api/user";
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
    name: "Index",
    components: {
        swiper,
        swiperSlide,
        indexGoods
    },
    props: {},
    data: function() {
        return {
            mobileBD: '',
            sms: '',
            mobileShow: true,
            time: 60,
            keyCode: '',
            index_new: require("../../assets/newImg/index_new.png"),
            newGoodsBananr: "",
            isWeixin: isWeixin(),
            followUrl: "",
            subscribe: false,
            followHid: false,
            followCode: false,
            showCoupon: false,
            logoUrl: "",
            banner: [],
            menus: [],
            roll: [],
            activity: [],
            activityOne: {},
            info: {
                fastList: [],
                bastBanner: [],
                firstList: [],
                bastList: []
            },
            likeInfo: [],
            lovely: [],
            benefit: [],
            couponList: [],
            swiperOption: {
                pagination: {
                    el: ".paginationBanner",
                    clickable: true
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true,
                on: {
                    tap: function() {
                        const realIndex = this.realIndex;
                        vm.goUrl(realIndex);
                    }
                }
            },
            swiperRoll: {
                direction: "vertical",
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true
            },
            swiperScroll: {
                freeMode: true,
                freeModeMomentum: false,
                slidesPerView: "auto",
                observer: true,
                observeParents: true
            },
            swiperBoutique: {
                pagination: {
                    el: ".paginationBoutique",
                    clickable: true
                },
                autoplay: {
                    disableOnInteraction: false,
                    delay: 2000
                },
                loop: true,
                speed: 1000,
                observer: true,
                observeParents: true
            },
            swiperProducts: {
                freeMode: true,
                freeModeMomentum: false,
                slidesPerView: "auto",
                observer: true,
                observeParents: true
            },
            mapKey: "",
            isShow: false,
            is_show_success: false
        };
    },
    created() {
        vm = this;
    },
    created() {
        // this.bankCard();
    },
    watch: {
        '$route.path': function(newVal, oldVal) {
            console.log('欢迎进入登录页面');
            // console.log('欢迎进入注册页面');
        }
    },
    mounted: function() {
        this._onShowLoading();
        this._onQueryBindAccount();
        this.getFollow();
        let that = this;
        // that.getUserInfo();
        that.bankCard();
        that.getCode();
        getHomeData()
            .then(res => {
                that.mapKey = res.data.tengxun_map_key;
                localStorage.setItem(MAPKEY, that.mapKey);
                localStorage.setItem('historyRouter', '');
                that.logoUrl = res.data.logoUrl;
                localStorage.setItem("logoUrl", res.data.logoUrl)
                that.newGoodsBananr = res.data.newGoodsBananr;
                that.$set(that, "banner", res.data.banner);
                that.$set(that, "menus", res.data.menus);
                that.$set(that, "roll", res.data.roll);
                that.$set(that, "activity", res.data.activity);
                // if (res.data.activity.length) {
                //   var activityOne = res.data.activity.shift();
                //   that.$set(that, "activityOne", activityOne);
                // }
                that.$set(that, "info", res.data.info);
                that.$set(that, "likeInfo", res.data.likeInfo);
                // that.$set(
                //   that,
                //   "lovely",
                //   res.data.lovely.length ? res.data.lovely[0] : {}
                // );
                that.$set(that, "benefit", res.data.benefit);
                that.$set(that, "couponList", res.data.couponList);
                that.subscribe = res.data.subscribe;
                if (!that.subscribe && that.followUrl) {
                    setTimeout(function() {
                        that.followHid = true;
                    }, 200);
                } else {
                    that.followHid = false;
                }
                if (res.data.site_name) document.title = res.data.site_name;
                that.setOpenShare();
                this.showCoupon = !localStorage.getItem(HAS_COUPON_WINDOW) &&
                    res.data.couponList.some(coupon => coupon.is_use);
                if (!localStorage.getItem(LATITUDE) && !localStorage.getItem(LONGITUDE)) this.getWXLocation();
                that._onHideLoading();
            })
            .catch(res => {
                that._onHideLoading();
            });
    },
    methods: {
        // 轮播图跳转
        goUrl(index) {
            let url = this.banner[index].wap_url;
            let newStr = url.indexOf("http") === 0;
            if (newStr) {
                window.location.href = url;
            } else {
                this.$router.push({
                    path: url
                });
            }
        },
        /**发送验证码 */
        send() {
            let mobileBD = this.mobileBD,
                reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/
            if (!reg.test(mobileBD)) {
                Toast('手机号有误');
                return
            }
            registerVerify({
                phone: mobileBD,
                key: this.keyCode
            }).then(res => {
                this.timer()
            })
        },
        timer() {
            let promise = new Promise((resolve, reject) => {
                let setTimer = setInterval(
                    () => {
                        this.time = this.time - 1
                        if (this.time <= 0) {
                            this.time = 60
                            resolve(setTimer)
                        }
                    }, 1000)
            })
            promise.then((setTimer) => {
                clearInterval(setTimer)
            })
        },
        mobileCancel(e) {
            let mobileBD = this.mobileBD,
                sms = this.sms,
                reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/
            if (!reg.test(mobileBD)) {
                Toast('手机号有误');
                return
            }
            if (sms == '') {
                Toast('验证码不能为空');
                return
            }
            bindPhone({
                captcha: sms,
                phone: mobileBD
            }).then(res => {
                Toast(res.msg);
                this.getUserInfo()
            })
        },
        getCode() {
            getCodeApi()
                .then(res => {
                    this.keyCode = res.data.key;
                })
                .catch(res => {
                    this.$dialog.error(res.msg);
                });
        },
        /**跳转客服 */
        kefu() {
            window.location.href = this.Constants.WECHAT_CUSTOMER_SERVICES
        },
        // 商品详情跳转
        goDetail(item) {
            goShopDetail(item).then(() => {
                this.$router.push({ path: "/detail/" + item.id });
            });
        },
        getWXLocation() {
            if (isWeixin()) {
                wxShowLocation();
            } else {
                if (!this.mapKey) {
                    // console.log("暂无法使用查看地图，请配置您的腾讯地图key");
                }
                let loc;
                // if (_this.$route.params.mapKey) _this.locationShow = true;
                //监听定位组件的message事件
                window.addEventListener(
                    "message",
                    function(event) {
                        loc = event.data; // 接收位置信息 LONGITUDE
                        // console.log("location", loc);
                        if (loc && loc.module == "geolocation") {
                            localStorage.setItem(LATITUDE, loc.lat);
                            localStorage.setItem(LONGITUDE, loc.lng);
                        } else {
                            localStorage.removeItem(LATITUDE);
                            localStorage.removeItem(LONGITUDE);
                            //定位组件在定位失败后，也会触发message, event.data为null
                            // console.log("定位失败");
                        }
                    },
                    false
                );
            }
        },
        closeFollow() {
            this.followHid = false;
        },
        followTap() {
            this.followCode = true;
            this.followHid = false;
        },
        closeFollowCode() {
            this.followCode = false;
            this.followHid = true;
        },
        couponClose() {
            localStorage.setItem(HAS_COUPON_WINDOW, 1);
        },
        getFollow() {
            follow()
                .then(res => {
                    this.followUrl = res.data.path;
                })
                .catch(() => {});
        },
        setOpenShare() {
            if (isWeixin()) {
                getShare().then(res => {
                    var data = res.data.data;
                    var configAppMessage = {
                        desc: data.synopsis,
                        title: data.title,
                        link: location.href,
                        imgUrl: data.img
                    };
                    openShareAll(configAppMessage);
                });
            }
        },

        /**完善银行卡信息 */
        cardSuccess() {
            this.$router.push("/card_inform");
        },
        getUserInfo() {
            getUserInfo().then(res => {
                localStorage.setItem("uid", res.data.uid);
                // this.bankCard();
                this.mobileShow = res.data.phone ? false : true
            });
        },
        /**查询银行卡信息是否完善 */
        bankCard() {
            console.log('this.userInfo---->', this.userInfo);
            if (!this.userInfo || !this.userInfo.token) return;
            queryBindStatus().then(res => {
                this.isShow = res.data;
                // this.is_show_success=true;
            }).catch(err => {
                this.is_show_success = true;
            })
        }
    }
};
</script>
<style scoped>
[v-cloak] {
    display: none;
}

.index {
    background-color: #fff;
}

.index .follow {
    z-index: 100000;
}

.keep {
    text-align: center;
}

.index .banner {
    width: 7rem;
    margin: 0 auto;
    border-radius: 10px;
    height: 4rem !important;
}

.index .banner img {
    height: 4rem;
}

.index-bg {
    background: url("../../assets/newImg/index_bg.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 4.2rem;
    margin-bottom: 56px;
}

.index .header .search {
    width: 190px;
    height: 28px;
    background: rgba(255, 255, 255, 0.4);
    color: #ffffff;
}

.index .header .logo {
    width: 106px;
    height: 36px;
}

.index .header {
    height: 56px;
}

.index-video {
    width: 100%;
    height: 160px;
    overflow: hidden;
    margin-top: 22px;
    position: relative;
}

.index-video video {
    width: 100%;
    height: 100%;
}

.index-video .poster {
    width: 100%;
    height: 100%;
}

.index-video .start-img {
    width: 40px;
    height: 32px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
}

.index .nav {
    box-shadow: 0px 2px 14px 0px rgba(228, 228, 228, 0.82);
    margin-bottom: 0.26rem;
    overflow-x: scroll;
    display: flex;
    flex-wrap: nowrap;
    height: 2rem;

}

.index .nav .item {
    width: auto;
    /*margin-right: 50px;*/
}

.index .nav .item .local {
    width: 1.5rem;
}

.card {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    padding: 0 11px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: calc(1rem + env(safe-area-inset-bottom));
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
}

.card .card-left {
    display: flex;
}

.card img {
    width: 20px;
    height: 20px;
}

.card .content {
    padding-left: 10px;
    font-size: 13px;
    color: #ffffff;
}

.card .succ {
    width: 52px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #d01112;
    border-radius: 13px;
    color: #fff;
    font-size: 12px;
}

.goods-bg {
    width: 100%;
    height: 99px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: url("../../assets/newImg/index_goods_bg.png") no-repeat;
    background-size: 100% 100%;
}

.goods-bg .txt {
    width: 144px;
    height: 40px;
    background: url("../../assets/newImg/index_goods_bg_txt.png") no-repeat;
    background-size: 100% 100%;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.goods-bg .txt span {
    width: 36px;
    text-align: center;
    display: inline-block;
}

.goods-bg .txt-con {
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: justify;
    color: #666666;
    padding-top: 8px;
}

.speak {
    background: url('../../assets/newImg/project_bg.png') no-repeat;
    background-size: 100% 100%;
    height: 5.5rem;
}

.speak .speak-news {
    /* height: 132px; */
    margin: 0 10px;
}

.speak .speak-news img {
    width: 100%;
    height: 132px;
    object-fit: cover;
}

.speak .speak-new {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px;
}

.speak .speak-new img {
    width: 3.4rem;
    /* height: 74px; */
}

.kefu {
    position: fixed;
    right: 16px;
    bottom: 165px;
    z-index: 1000;
    width: 60px;
    height: 60px;
}
</style>